// How a squad is grouped for the team cards.
//
// The curator's own Teams page and the public one both read
// `team.filteredPlayers`, so they bucket the same way here rather than each
// keeping its own copy that can drift.
const EMPTY = () => ({
  Batter: [],
  Bowler: [],
  Wicketkeeper: [],
  "All Rounder": [],
  Uncapped: [],
  Indians: [],
  Overseas: [],
});

const isIndian = (nationality) =>
  ["india", "indian"].includes(String(nationality || "").toLowerCase());

// `entries` are squad rows, each `{ Bid, Player }`.
export const bucketSquad = (entries) => {
  const filteredPlayers = EMPTY();

  entries?.forEach((entry) => {
    const player = entry?.Player;
    if (!player) return;

    // A role outside these four buckets used to throw here and take the whole
    // team view down mid-auction. Count it, just not by role.
    const bucket = filteredPlayers[player?.role];
    if (bucket) bucket.push(entry);

    if (player?.uncapped) filteredPlayers.Uncapped.push(entry);
    if (isIndian(player?.nationality)) filteredPlayers.Indians.push(entry);
    else filteredPlayers.Overseas.push(entry);
  });

  return filteredPlayers;
};

// A whole board of teams, each given its `filteredPlayers`.
export const withSquads = (teams) =>
  (teams || []).map((team) => ({
    ...team,
    filteredPlayers: bucketSquad(team?.players),
  }));

export default withSquads;
